import React from 'react';
import logo from './logo.svg';
import './App.css';
import Counter from './Counter';
import CounterSafe from './CounterSafe';
import CounterAutoChallenge from './CounterAutoChallenge';
import CounterTest from './counterTest';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <Counter />
        <CounterSafe />
        <CounterAutoChallenge />
        <CounterTest />
        <img src={logo} className="App-logo" alt="logo" />
        <a
          className="App-link"
          href="https://reactjs.org"
          target="_blank"
          rel="noopener noreferrer"
        >
        </a>
      </header>
    </div>
  );
}

export default App;
